import React from "react"
import {GridCellProps } from "@progress/kendo-react-grid"
import { useNavigate } from "react-router"
import { useAppDispatch } from "../../../../app/hooks";
import { GridButton } from "../../../../components";
import { caseManageApi } from "../../../../services/caseManService/caseManage-api";

function CaseManViewCell(props:GridCellProps){
    const navigate = useNavigate();
    const dispatch = useAppDispatch(); 

    return <React.Fragment>
        <GridButton variant='outlined' size='small' onClick={()=>
            {navigate('/CaseManDetail/'+props.dataItem.id); 
            dispatch(caseManageApi.util.invalidateTags(['CaseMan']));
            }}>View</GridButton>
    </React.Fragment>
}

export {CaseManViewCell}